/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockSupplierAddCtrl
 */
angular.module('mercury.modules.stock.supplier')
.controller('StockSupplierAddCtrl', ["dialog", "existingMasterSuppliers", "$filter", "$scope", "StockMasterSuppliers", "StockSuppliers", function(dialog, existingMasterSuppliers, $filter, $scope, StockMasterSuppliers, StockSuppliers) {
  $scope.masterSuppliers = StockMasterSuppliers.getAll();
  $scope.masterSuppliers.$promise.then(function() {
    $scope.masterSuppliers = $filter('filter')($scope.masterSuppliers, function(masterSupplier) {
      return existingMasterSuppliers.indexOf(masterSupplier.id) == -1;
    });
  });

  $scope.supplier = {};
  $scope.form = {};

  /**
  * Called back for 'Add From Prefered List' auto complete. Add the selected master supplier to the site list then close the popup
  */
  $scope.addPreferedSupplier = function(masterSupplier) {
    if (masterSupplier) {
      $scope.supplier = angular.copy(masterSupplier);
      $scope.supplier.masterId = masterSupplier.id;
      delete $scope.supplier.id;
    } else {
      $scope.supplier = {};
    }
  };

  /**
  * Create a new supplier within the database
  */
  $scope.create = function() {
    $scope.form.supplierAddForm.$setSubmitted();
    if ($scope.form.supplierAddForm.$invalid) {
      return;
    }

    StockSuppliers.create($scope.supplier)
    .then(function(newSupplier) {
      $scope.$close(newSupplier);
    });
  };
}]);
